<template>
  <snap-modal
    v-show="isOpened"
    @snap-modal-close="close"
    :_title="title"
    prompt
  >
    <snap-icon
      v-if="type == 'warning'"
      icon="exclamation-solid"
      color="#D97706"
      size="md"
      state="rounded"
      bg-color="#FEF3C7"
    ></snap-icon>

    <slot />

    <snap-button
      v-if="wideCloseButton"
      @click="close"
      full-width
      size="md"
      variant="primary"
      >Continue</snap-button
    >
  </snap-modal>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

type ModalType = "warning";

@Options({
  props: ["type", "title", "wideCloseButton"],
})
export default class Modal extends Vue {
  type: ModalType = "warning";
  title?: string;
  wideCloseButton?: boolean;
  isOpened: boolean = true;

  close() {
    this.isOpened = false;
  }
}
</script>
